import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor 
} from '@angular/common/http';
import { Observable, of } from 'rxjs'; 
import { urlConstants } from '../app/common/urlConstants';
import { GlobalService } from '../app/services/global.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private readonly globalVariable:GlobalService) {}

  // List of endpoints that don't require context
  private readonly exemptUrls: string[] = [urlConstants.userSystemInfoUrl,
     urlConstants.userAllSystemInfoUrl, urlConstants.registerPrincipleUrl, urlConstants.directRetrieval];

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const contextSet =  this.globalVariable.getSelectedSystemId !== '' ? true : false ;

    const isExempt = this.exemptUrls.some(url => req.url.includes(url));

    if (!contextSet && !isExempt) {
      // Block the request
      return of();
    }

    return next.handle(req);
  }
}